export const colors = ['#042464', '#72b734', '#fc0808']
